/* eslint-disable @next/next/no-img-element */
import React, { Fragment } from 'react'
import DOMPurify from 'dompurify'
import { useSelector } from 'react-redux'
import { Segment, Container, GridRow, GridColumn, Grid } from 'semantic-ui-react'
import _ from 'lodash'

import { mergeStyles } from '@enlyt/helpers/mergeStyles'
import { getAccountDetails, getCurPatientData } from 'stores/Account/Select'
import { getExternalLinks } from 'stores/Links/Select'

import useMediaQuery from 'hooks/useMediaQuery'
import PatientSwitch from 'components/PatientSwitch'

import HeroFamily from '@images/custom/images/topBanner/topBanner.png'

import { useTheme } from 'contexts/ThemeProvider'

import themeStyles from './styles'
import { localization } from './localization'
import withLocalization from '@web/helpers/localizationUtils'

const PatientInfo = ({ t }) => {
  const { theme } = useTheme()
  const defaultStyles = themeStyles(theme)
  const styles = mergeStyles(defaultStyles)
  const accountDetails = useSelector(getAccountDetails) ?? { firstname: '' }
  const curPatient = useSelector(getCurPatientData) ?? { firstname: '' }
  const isUser = _.get(curPatient, 'isUser', false)

  return (
    <div style={styles.accountInfoContainer}>
      <div style={styles.accountInfo}>
        <div style={styles.accountInfoTitle}>{t('hello')}, {accountDetails?.firstname?.toUpperCase()}</div>
        {!isUser && <div style={styles.accountInfoText}>{t('viewingHealthRecordFor')} <strong>{curPatient?.firstname?.toUpperCase()}</strong></div>}
        <PatientSwitch switchButtonStyle={{ marginLeft: 0 }} />
      </div>
    </div>
  )
}

const SafetyBanner = () => {
  const dynamicBanner = _.get(useSelector(getExternalLinks), 'DynamicBanner')
  const styleMatch = !_.isEmpty(dynamicBanner) && _.get(dynamicBanner, 'UFD_Dynamic_Banner_Content').match(/<style[^>]*>[\s\S]*?<\/style>/gi)
  const stylesTag = styleMatch ? styleMatch.join('') : ''
  return _.isEmpty(dynamicBanner) ? <div /> : <div dangerouslySetInnerHTML={{ __html: !_.isEmpty(DOMPurify.sanitize(_.get(dynamicBanner, 'UFD_Dynamic_Banner_Content'))) && DOMPurify.sanitize(_.get(dynamicBanner, 'UFD_Dynamic_Banner_Content')) + stylesTag }} />
}

const WelcomeComponent = ({ style, t }) => {
  const { isMobile, isTablet } = useMediaQuery()
  const { theme } = useTheme()
  const defaultStyles = themeStyles(theme)
  const styles = mergeStyles(defaultStyles, style)
  const accountDetails = useSelector(getAccountDetails) ?? { firstname: '' }
  const curPatient = useSelector(getCurPatientData) ?? { firstname: '' }
  const isUser = _.get(curPatient, 'isUser', false)
  const dynamicBanner = _.get(useSelector(getExternalLinks), 'DynamicBanner')

  return (
    <Fragment>
      {!(isMobile || isTablet) &&
        <Segment style={styles.relative}>
          <div style={styles.container}>
            <img style={styles.backgroundImg} alt={_.get(dynamicBanner, 'contentTitle', '')} src={_.get(dynamicBanner, 'resourceUrl', HeroFamily)} />
            <Container>
              <Grid divided="vertically">
                <GridRow>
                  <GridColumn width={10}><SafetyBanner /></GridColumn>
                  <GridColumn width={6}><PatientInfo t={t} /></GridColumn>
                </GridRow>
              </Grid>
            </Container>
          </div>
        </Segment>
      }
      {isTablet &&
        <Segment style={styles.relative}>
          <div style={styles.container}>
            <img style={styles.backgroundImg} alt={_.get(dynamicBanner, 'contentTitle', '')} src={_.get(dynamicBanner, 'resourceUrl', HeroFamily)} />
            <Container>
              <Grid divided="vertically">
                <GridRow>
                  <GridColumn width={10}><SafetyBanner /></GridColumn>
                  <GridColumn width={6}><PatientInfo t={t} /></GridColumn>
                </GridRow>
              </Grid>
            </Container>
          </div>
        </Segment>
      }
      {isMobile &&
        <Segment style={styles.relative}>
          <div style={styles.mobileContainer}>
            <img style={styles.mobileBackgroundImg} alt={_.get(dynamicBanner, 'contentTitle', '')} src={_.get(dynamicBanner, 'resourceUrl', HeroFamily)} />
            <div style={styles.mobileBanner}>
              <SafetyBanner />
            </div>
          </div>
          <div style={styles.mobileAccountInfoContainer}>
            <Container>
              <div style={styles.mobileAccountInfo}>
                <div style={styles.accountInfoTitle}>{t('hello')}, {accountDetails?.firstname?.toUpperCase()}</div>
                {!isUser && <div style={styles.accountInfoText}>{`${t('viewingHealthRecordFor')} `} <strong>{curPatient.firstname?.toUpperCase()}</strong></div>}
                <PatientSwitch switchButtonStyle={styles.patientSwitchButtonInMobile} />
              </div>
            </Container>
          </div>
        </Segment>
      }
    </Fragment>
  )
}

export const Welcome = withLocalization(WelcomeComponent, localization)
